module.exports = __webpack_public_path__ + "static/media/virtus.1c6b241b.png";